import { createAction, props } from '@ngrx/store';
import { User } from '@storytemple/models';

export const setLoggedInUser = createAction('[LoggedInUser] setLoggedInUser', props<{ user: User }>());
